<template>
  <div class="issueSliderBullets">
      <issue-slider-bullet
        v-for="(value , index) in pages"
        :key="index"
        :id="index+1"
        @handleSliderBullet="_slideTo"
      />
  </div>
</template>

<script>
    import IssueSliderBullet from '@/components/menu/Sunnyfactory/IssueSliderBullet'

    export default {
      components: {IssueSliderBullet},
      name: "issue-slider-bullets",
      props:['pages'] ,
      component : {
        IssueSliderBullet
      },
      methods : {
        _slideTo (id) {
          //console.log('id' , id);
          //this.$parent.$refs[issue-item-slider].$emit('slideTo', id);
          this.$parent.$refs['issue-item-slider'].$emit('slideTo' , id - 1);
          this.$store.commit('issueSliderBulletStore/slideChange' , {currentPage : id})
        }
      }
    }
</script>

<style scoped lang="scss">
  @import "@/styles/Sunnyfactory.scss";

</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/IssueSliderBullets.vue